<template>
    <b-field :label="label"
             :type="error?'is-danger':''"
             :message="error">
        <b-timepicker
                :value="time"
                :placeholder="placeholder"
                :min-time="min"
                :max-time="max"
                @input="setValue"
                :inline="inline"
                icon="clock"
                hour-format="12">
        </b-timepicker>
    </b-field>
</template>

<script>
    export default {
        name: "FormTime",
        data() {
            return {
                time: new Date(),
            }
        },
        props: {
            value: Date|String,
            label: {
                type: String,
                default: 'Selecciona una hora'
            },
            error: {},
            holder: {
                type: String,
                default: 'Selecciona una hora'
            },
            inline: {},
            icon: {
                type: String,
                default: 'calendar'
            },
            min: {},
            max: {},
        },
        watch: {
            value(val) {
                if (typeof val === 'string') {
                    this.time = new Date(val);
                }
            }
        },
        mounted() {
            this.time = new Date(this.value || new Date());
        },
        methods: {
            setValue(val) {
                this.$emit('input', moment(val).format());
            }
        }
    }
</script>

<style scoped>

</style>